import React, { useState, useEffect } from 'react';
import { adminService } from '../services/api';

export default function AccessRequests() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [inviting, setInviting] = useState({});
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    adminService.listAccessRequests()
      .then(data => setRequests(data.requests || []))
      .catch(() => setError('Failed to load access requests'))
      .finally(() => setLoading(false));
  }, []);

  const handleInvite = async (req) => {
    setInviting(prev => ({ ...prev, [req.request_id]: true }));
    setMessage({ type: '', text: '' });
    try {
      const res = await adminService.inviteUser({
        email: req.email,
        given_name: req.first_name,
        family_name: req.last_name,
        partner_company: req.company,
        partner_country: req.country,
        is_ck_admin: false,
        request_id: req.request_id
      });
      setMessage({
        type: 'success',
        text: `Invited ${req.email}. Welcome email sent. Temp password: ${res.temp_password}`
      });
      // Update status in local state
      setRequests(prev => prev.map(r =>
        r.request_id === req.request_id ? { ...r, status: 'invited' } : r
      ));
    } catch {
      setMessage({ type: 'error', text: `Failed to invite ${req.email}` });
    } finally {
      setInviting(prev => ({ ...prev, [req.request_id]: false }));
    }
  };

  if (loading) return <div className="loading">Loading access requests…</div>;
  if (error) return <div className="message error">{error}</div>;

  return (
    <div className="access-requests-panel">
      <h3>Partner Access Requests ({requests.length})</h3>
      {message.text && <div className={`message ${message.type}`}>{message.text}</div>}
      {requests.length === 0 ? (
        <p className="no-data">No access requests yet.</p>
      ) : (
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Company</th>
                <th>Country</th>
                <th>Message</th>
                <th>Submitted</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {requests.map(r => (
                <tr key={r.request_id}>
                  <td>{r.first_name} {r.last_name}</td>
                  <td>{r.email}</td>
                  <td>{r.company}</td>
                  <td>{r.country}</td>
                  <td className="req-message">{r.message || '—'}</td>
                  <td>{r.created_at ? new Date(r.created_at).toLocaleDateString() : '—'}</td>
                  <td>
                    <span className={`badge badge-${r.status === 'invited' ? 'synced' : 'submitted'}`}>
                      {r.status === 'invited' ? 'Invited' : 'Pending'}
                    </span>
                  </td>
                  <td>
                    {r.status !== 'invited' ? (
                      <button
                        className="btn-primary btn-sm"
                        onClick={() => handleInvite(r)}
                        disabled={inviting[r.request_id]}
                      >
                        {inviting[r.request_id] ? 'Inviting…' : 'Invite'}
                      </button>
                    ) : (
                      <span style={{ fontSize: '0.8rem', color: '#1DBE9C', fontWeight: 600 }}>✓ Done</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
